var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":_vm.abreModal}},[_c('feather-icon',{staticClass:"text-success",attrs:{"badge":_vm.countNovasMensagens,"badge-classes":"bg-success","size":"21","icon":"MessageCircleIcon"}}),_c('ChatModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }